import { render, staticRenderFns } from "./OnlineUser.vue?vue&type=template&id=d8b38890&"
import script from "./OnlineUser.vue?vue&type=script&lang=js&"
export * from "./OnlineUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports